var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a class=\"help_link_widget\" href=\""
    + container.escapeExpression((((helper = lookupProperty(helpers,"link") || container.strict(depth0, "link", {"start":{"line":1,"column":37},"end":{"line":1,"column":41}} ))),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":1,"column":34},"end":{"line":1,"column":44}}}) : helper)))
    + "\" target=\"_blank\" rel=\"noopener noreferrer\">\n    <i class=\"fa fa-question-circle-o\" aria-hidden=\"true\"></i>\n</a>\n";
},"useData":true});